/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import ResultComponent from 'cio/components/newsletters/results';

import { Measure } from 'cio/utils/metrics/common';
import { capitalize } from '@ember/string';
import { getDefaultTemplateForTestGroup } from 'cio/utils/newsletter-testgroups';
import TemplateModel from 'cio/models/template';

interface MetricHeader {
  label: string;
  class?: string;
  metric: Measure;
}

type NewsletterResultTestType = Extract<Measure, 'sent' | 'opened' | 'clicked' | 'converted' | 'failed'>;

// This component is inheriting from its parent for DRY reasons
// because it shares some code with LanguageMetrics component.
export default class TestResults extends ResultComponent {
  readonly irrelevantMetricHeaders: Record<string, NewsletterResultTestType[]> = {
    twilio: ['opened'],
    push: ['clicked'],
  };

  get metricHeaders(): MetricHeader[] {
    let denominator: Measure = this.environment.current.metricDenominator;

    if (!this.args.newsletter?.channelInfo.metrics.includes(denominator)) {
      denominator = 'sent';
    }

    let headers = [denominator, ...this.relevantHeaders()].map((metric: NewsletterResultTestType) => {
      let header: MetricHeader = {
        label: capitalize(metric),
        metric,
      };

      if (metric !== denominator || metric !== 'failed') {
        header = { ...header, class: this.args.highlightedRow === metric ? 'text-default' : undefined };
      }
      return header;
    });

    return headers;
  }

  get visibleMetricHeaders(): MetricHeader[] {
    return this.metricHeaders.filter((header) => this.args.newsletter?.channelInfo.metrics.includes(header.metric));
  }

  private relevantHeaders() {
    let { testGroupIds } = this;
    let defaultTemplate: TemplateModel | null = null;

    for (let i = 0; i < testGroupIds.length; i++) {
      let template = getDefaultTemplateForTestGroup(testGroupIds[i], this.templates);
      if (template != null) {
        defaultTemplate = template;
        break;
      }
    }
    let templateType = defaultTemplate?.templateType ?? '';
    return ['opened', 'clicked', 'converted', 'failed'].filter(
      (header: NewsletterResultTestType) => !(this.irrelevantMetricHeaders[templateType] ?? []).includes(header),
    );
  }
}
